<template>
  <div id="register">
    <section class="section">
      <div class="container mt-5">
        <div class="row">
          <div class="col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3">
            <div class="login-brand">
              <a href="/">
                <img
                  :src="require('@/assets/img/icon-jembrana-20.png')"
                  alt="logo"
                  width="100"
                  class="shadow-light"
                  @click="$router.push({path: '/'})"
                  style="cursor:pointer"
                >
              </a>
              <h4 class="text-dark font-weight-normal mt-4">
                <span class="font-weight-bold">SiPeDuLi Jembrana</span>
              </h4>
            </div>

            <div class="card card-primary">
              <div class="card-header">
                <h4>Validasi OTP</h4>
              </div>

              <div class="card-body">
                <!-- <div class="alert alert-danger alert-has-icon">
					<div class="alert-icon"><i class="far fa-lightbulb"></i></div>
					<div class="alert-body">
						<div class="alert-title">Tidak Diizinkan</div>
						NIK Sudah Terdaftar
					</div>
					</div> -->
                <form
                  method="POST"
                  @submit="onSubmit"
                >
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="kode_otp">Masukkan Kode OTP</label>
                        <input
                          id="kode_otp"
                          type="text"
                          class="form-control form-control-lg text-center"
                          autofocus
                          required
                          v-model="form.kode_otp"
                        >
                        <small>Kode OTP dapat diminta di Kantor Desa setempat</small>
                      </div>
                    </div>
                  </div>
					
					
					

                  <div class="form-group">
                    <!-- <router-link to="/login" tag="button" class="btn btn-primary btn-lg btn-block">
						Daftar
						</router-link> -->
                    <button
                      id="btnSubmit"
                      type="submit"
                      class="btn btn-primary btn-lg btn-block"
                    >
                      Validasi
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="simple-footer">
              Copyright &copy; 2021 Dinas Komunikasi Dan Informatika Kabupaten Jembrana
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>

</style>

<script>
import swal from 'sweetalert'
export default {
  name: 'App',
  data() {
    return {
      form: {
        kode_otp: null
      }
    }
  },
  computed: {
    profile() {
      return this.$store.getters.getUserProfile
    }
  },
  components: {

  },
  methods: {

    onSubmit(e) {
      e.preventDefault()

      let button = document.querySelector('#btnSubmit')
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Validasi'

      let formData = new FormData()
      formData.append('kode_otp', this.form.kode_otp)

      this.$store.dispatch('validateOtp', formData).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: "Akun terverifikasi",
            icon: "success",
            buttons: "Ok"
          }).then((result) => {
            if (result.value) {
              window.location = '/home'
            } else {
              window.location = '/home'
            }
          })
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
            .then((result) => {
              if (result) {
                if (result.value) {
                  window.location = ''
                } else {
                  window.location = ''
                }
              } else {
                window.location = ''
              }
            })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      }).catch(err => {
        // console.log(err)
        if (err.response.status === 401) {
          this.$store.dispatch('logoutUser')
        } else if (err.response.status === 500) {
          this.$router.push({ path: '/500' })
        }
      })






    }
  },
  mounted() {

  }
}
</script>

<style>

</style>
